<template>
  <div class="pbanner" id="banner">
    <figure data-scroll data-scroll-offset="0" data-scroll-position="top" data-scroll-sticky data-scroll-target="#app">
      <img class="mimgs" src="@/assets/images/banner1.png" alt=""/>
       <video v-show="!offOn" class="banner-video" id="banner-video" ref="movie" preload="auto" x5-video-player-type="h5" x5-video-player-fullscreen="true" x-webkit-airplay="allow" webkit-playsinline playsinline muted autoplay>
        <source :src="bannerV" type="video/mp4">
			</video>

      <video v-show="offOn" class="change-video" id="change-video" ref="chanageVideo" preload="auto" x5-video-player-type="h5" x5-video-player-fullscreen="true" x-webkit-airplay="allow" webkit-playsinline playsinline muted loop>
        <source :src="bannerV1" type="video/mp4">
			</video>
    </figure>
    <div class="group_3 flex-row" :class="{show: bannerStatus}">
      <div class="image-wrapper_2 flex-row">
        <img class="image_3"
          src="@/assets/images/ice-block.png"
        />
      </div>
      <div class="text-wrapper_2 flex-col">
        <span class="text_6"
          >RTE&nbsp;2022&nbsp;第八届实时互联网大会，我们将推出实时互联网全生态的论坛及活动&nbsp;20&nbsp;余场，覆盖技术、行业、创投、趋势等多维度话题，更有&nbsp;Metaverse、VR&nbsp;/&nbsp;AR&nbsp;等时下最热门场景的现场体验。</span
        >
        <div class="sign-up sign-box">
          <a target="_block" href="https://www.bagevent.com/event/8278845">立即报名</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      offOn: false,
      bannerV: require('@/assets/video/banner1.mp4'),
      bannerV1: require('@/assets/video/banner2.mp4')
    }
  },
  props: ['bannerStatus'],
  methods: {
    startAnimate () {
      this.$refs.movie.play();
      this.$refs.movie.addEventListener("ended", () => {
        this.offOn = true;
        this.$refs.chanageVideo.play();    
      });
    },
  },
  mounted () {
    this.startAnimate()
  }
}
</script>

<style lang="less" scoped>
@import url("@/assets/css/home/index.less");
</style>
